import React from "react"
import { defineMessages, injectIntl } from "react-intl"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend/index"
import SurveyComponent from "../components/SurveyComponent"
import { SIGN_UP_OPTIONS } from "../../state/onboarding/DataFlowMaps"
import { SIGN_UP_OPTION } from "../../state/onboarding/DataFlowTypes"
import { INTEGRATION_KEY } from "../../state/integration/Constants"
import { Intl } from "../../state/helpers/IntlProps"

const titleMessages = defineMessages({
    [INTEGRATION_KEY.SHOPIFY]: {
        id: "onboarding.sign_up_survey.shopify_title",
        defaultMessage: "How do you use Shopify ?",
    },
    [INTEGRATION_KEY.SHOPIFY_EXPERT_APP]: {
        id: "onboarding.sign_up_survey.shopify_title",
        defaultMessage: "How do you use Shopify ?",
    },
})

const optionMessages = defineMessages({
    [SIGN_UP_OPTION.ECOM_MANAGEMENT]: {
        id: "onboarding.sign_up_survey.option_ecom",
        defaultMessage: "To manage an Ecommerce",
    },
    [SIGN_UP_OPTION.RUN_BRICK_AND_MORTAR]: {
        id: "onboarding.sign_up_survey.option_brick_and_mortar",
        defaultMessage: "To run a brick-and-mortar store",
    },
    [SIGN_UP_OPTION.SELL_B2B]: {
        id: "onboarding.sign_up_survey.option_b2b",
        defaultMessage: "To sell to businesses (B2B)",
    },
    [SIGN_UP_OPTION.SELL_TO_CUSTOMERS]: {
        id: "onboarding.sign_up_survey.option_customers",
        defaultMessage: "To sell to consumers",
    },
    [SIGN_UP_OPTION.WEB_AGENCY]: {
        id: "onboarding.sign_up_survey.option_web_agency",
        defaultMessage: "I am from a web agency/IT consulting",
    },
})

type OwnProps = {
    intl: Intl,
    onStepCompleted: (payload) => object,
    step: string,
}

const SignUpSurveyContainer = (props: OwnProps) => {
    const onStepCompletedCallback = (selection) => {
        props.onStepCompleted({
            "signUpSurveySelection": Array.from(selection)
        })
    }

    const integrationKey = AppContext.getAccount().attributes.integrationKey
    return (
        <SurveyComponent
            onStepCompletedCallback={onStepCompletedCallback}
            title={props.intl.formatMessage(titleMessages[integrationKey])}
            options={SIGN_UP_OPTIONS[integrationKey]}
            messages={optionMessages}
        />
    )
}

export default injectIntl(SignUpSurveyContainer)


// WEBPACK FOOTER //
// ./src/onboarding/sections/SignUpSurveyContainer.tsx